import React from 'react';

import { QnA } from '@bizzabo/arena-components';
import FeatureToggleUtils from 'FeatureToggleUtils';

import RingQna from './RingQna';

const Qna = ({ session, event, mainColor, providerHasChat, ...qnaProps }) => {
    const isRingQna = FeatureToggleUtils.isFeatureEnabled('newQnaModule');
    const disableNewQnaModule = FeatureToggleUtils.isFeatureEnabled('disableNewQnaModule');

    if (isRingQna && !disableNewQnaModule) {
        return <RingQna {...qnaProps} session={session} event={event} mainColor={mainColor} providerHasChat={providerHasChat} />;
    }

    return <QnA {...qnaProps} />;
};

export default Qna;
